module.exports = __webpack_public_path__ + "fork_slight_right.svg?a51173a25b9eb73238e6eb091dc7d630";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork_slight_right.svg
// module id = 168
// module chunks = 0